import { saveLanguage, getLanguage } from '../lib/Language/language';

// Получить язык из URL параметров
export function getLanguageFromURL(): string | null {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('lang');
}

// Установить язык в URL
export function setLanguageInURL(lang: string) {
  const url = new URL(window.location.href);
  url.searchParams.set('lang', lang);
  window.history.replaceState({}, '', url.toString());
}

// Удалить параметр языка из URL
export function removeLanguageFromURL() {
  const url = new URL(window.location.href);
  url.searchParams.delete('lang');
  window.history.replaceState({}, '', url.toString());
}

// Получить текущий язык (приоритет: URL > localStorage > браузер)
export function getCurrentLanguage(): string {
  // Сначала проверяем URL
  const urlLang = getLanguageFromURL();
  if (urlLang && ['en', 'ro', 'ru'].includes(urlLang)) {
    return urlLang;
  }

  // Затем localStorage
  const storedLang = getLanguage();
  if (storedLang) {
    return storedLang;
  }

  // Наконец, язык браузера
  const browserLang = window.navigator.language || 'en';
  const shortLang = browserLang.split('-')[0];
  
  return ['en', 'ro', 'ru'].includes(shortLang) ? shortLang : 'en';
}

// Изменить язык (для использования с i18n.changeLanguage)
export function changeLanguage(lang: string) {
  // Сохраняем в localStorage
  saveLanguage(lang);
  
  // Всегда обновляем URL для сохранения параметра языка
  setLanguageInURL(lang);
}

// Инициализация языка при загрузке страницы
export function initializeLanguage() {
  const urlLang = getLanguageFromURL();
  
  if (urlLang && ['en', 'ro', 'ru'].includes(urlLang)) {
    // Если язык в URL отличается от сохраненного, обновляем localStorage
    const storedLang = getLanguage();
    if (storedLang !== urlLang) {
      saveLanguage(urlLang);
    }
  }
} 